import React, {useState} from 'react';
import {getHostIP} from '../../networking/Hosts';
import styles from './Chat.module.css';

// Existing saved conversations already contain GCJ-02 Amap marker URLs.
// Reading their coordinates also gives historical cards a real preview.
export function getClinicMapSource(clinic) {
    try {
        const url = new URL(clinic.map_url);
        if (url.hostname !== 'uri.amap.com' || url.pathname !== '/marker' ||
            url.searchParams.get('coordinate') !== 'gaode') return null;
        const position = url.searchParams.get('position')?.split(',');
        if (position?.length !== 2 || position.some(value => !value.trim())) return null;
        const [longitude, latitude] = position.map(Number);
        if (![longitude, latitude].every(Number.isFinite) || Math.abs(longitude) > 180 || Math.abs(latitude) > 90) return null;
        return `${getHostIP()}/api/clinicMap?longitude=${longitude.toFixed(6)}&latitude=${latitude.toFixed(6)}`;
    } catch {
        return null;
    }
}

export default function ClinicMapPreview({clinic}) {
    const source = getClinicMapSource(clinic);
    const [failedSource, setFailedSource] = useState(null);
    return <a className={`${styles.clinic_map_preview} ${styles.clinic_map_real}`}
        href={clinic.map_url} target="_blank" rel="noopener noreferrer"
        aria-label={`查看${clinic.name}地图`}>
        {source && failedSource !== source ? <>
            <img className={styles.clinic_map_image} src={source} alt={`${clinic.name}周边地图及位置标记`}
                loading="lazy" decoding="async" width="640" height="480" onError={() => setFailedSource(source)}/>
            <span className={styles.clinic_map_caption}>点击查看完整地图</span>
        </> : <span className={styles.clinic_map_fallback}>地图预览暂不可用<br/>点击查看地图</span>}
    </a>;
}
